import React from "react";



function Input({className, ...props }) {
    return (
        <>
            <input
                className={`${className}${' w-full px-4 py-2 bg-white mt-2 border border-gray-300 focus:ring-0 focus:shadow-none focus:outline-none focus:border-none '}`}
                {...props}
            />
        </>
    )
}
export default React.memo(Input);